const Condition = Object.freeze({
  RENOVATION_NEEDED: 'RENOVATION_NEEDED',
  WELL_MAINTAINED: 'WELL_MAINTAINED',
  NEW_OR_RECENTLY_RENOVATED: 'NEW_OR_RECENTLY_RENOVATED'
})

export default Condition
